import { action } from 'utils/actions'

export const NAVIGATION_DROPDOWN_TOGGLE = 'NAVIGATION_DROPDOWN_TOGGLE'

export const navigationDropdownToggle = () => action(NAVIGATION_DROPDOWN_TOGGLE)



/** WEBPACK FOOTER **
 ** ./src/actions/navigation/navigation-actions.js
 **/